import React from 'react';

import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { DatabaseTooltip } from '~src/spacesPlatform/components/tooltip/DatabaseTooltip';
import { doesTooltipNotHaveOwnerToDisplay } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { TooltipAnchor } from '~src/spacesPlatform/components/tooltip/TooltipAnchor';
import { getCommonDatabaseInfo, getGraphQLId, isContentInfoDatabase } from '~src/spacesPlatform/models/CommonDatabaseInfo';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { Messages } from '../../../codegen/Localize';
import { DatabaseThumbnail } from './DatabaseThumbnail';

export class DatabaseCard extends ContentCard {

    public render() {
        const content = this.props.content;
        const commonDatabase = getCommonDatabaseInfo(content);
        const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(content);

        const contentUrl = getDatabaseContentUrl(this.props.urls, this.props.content);

        return (
            <div className={CardViewStyles.Card}>
                <TooltipAnchor disableAutoFocus={disableAutoFocus}
                               disableTooltip={this.props.disableTooltip}
                               onShowTooltip={this.handleShowTooltip}
                               title={Messages.databaseDetails()}
                               tooltipContent={this.renderTooltipContent}
                               width={DetailsTooltipStyles.Width}>
                    <DatabaseThumbnail allowDragAndDrop={this.props.allowDragAndDrop}
                                       content={commonDatabase}
                                       contentUrl={contentUrl}
                                       hoveredOrSelected={this.props.hoveredOrSelected}
                                       aria-label={this.props.content.name}
                    />
                </TooltipAnchor>
                <div className={CardViewStyles.ActionRow}>
                    <span data-tb-test-id="database-name" className={CardViewStyles.ActionRowName} title={content.name}>
                        {content.name}
                    </span>
                    {this.renderActionsMenu()}
                </div>
                <div className={CardViewStyles.CardDescription}>
                    {this.getDescription()}
                </div>
            </div>
        );
    }

    private renderTooltipContent = () => {
        return <DatabaseTooltip content={this.props.content}
                            urls={this.props.urls}/>;
    };


}

export function getDatabaseContentUrl(urls: SpacesSiteUrls, content: IContentInfo): string {
    if (isContentInfoDatabase(content)) {
        const contentId = getGraphQLId(content);
        return urls.catalogDatabaseUrl(contentId);
      }

    return getContentUrlForItem(content, urls);
}
